import { render, staticRenderFns } from "./DemandChange.vue?vue&type=template&id=36dfc7f8"
import script from "./DemandChange.vue?vue&type=script&lang=js"
export * from "./DemandChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports